import UserIdentifiant from '@/generated/controls/user/UserIdentifiant.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: UserIdentifiant
})

